<template>
  <div class="user_page about-product admin_main">
    <v-card
      class="scan-qr_btn mb-3 d-flex justify-space-between align-center about-product__search"
    >
      <v-card-text>
        <ValidationObserver v-slot="{ handleSubmit }" ref="formObs">
          <form
            @submit.prevent="handleSubmit(getProductDetails)"
            class="d-flex"
          >
            <CustomInputText
              autofocus
              name="id"
              placeholder="ID"
              only="number"
              :rules="{ required: true }"
              v-model="qrCode"
              class="user_input no-margin pr-3"
            />
            <VBtn type="submit" color="primary">{{ $t("find") }}</VBtn>
          </form>
        </ValidationObserver>
      </v-card-text>
    </v-card>

    <div class="mt-4 about-product__main">
      <v-card class="mr-4 about-product__main__images" height="100%">
        <v-card-title class="pb-6">{{ $t("productPhoto") }}</v-card-title>
        <v-card-text>
          <div class="about-product__main__images__main-image">
            <transition name="fade" mode="out-in">
              <img v-if="mainPhoto" :src="mainPhoto" alt="" />
              <img v-if="images?.length" :src="images[0]" alt="" />
              <img
                v-else
                width="60"
                class="about-product__main__images__main-image__no-image"
                src="@/assets/img/image.svg"
                alt=""
              />
            </transition>
          </div>
          <div class="about-product__main__images__variants mt-3">
            <template v-for="(image, i) in images">
              <div
                :key="`variants-${i}`"
                class="d-flex align-center justify-center cursor-pointer about-product__main__images__variants__image"
                @click="changeMainImage(image)"
              >
                <img
                  :src="image"
                  alt="product-image"
                  class="about-product__main__images__variants__img-tag"
                />
              </div>
            </template>
          </div>
        </v-card-text>
      </v-card>
      <v-card class="about-product__main__info" height="100%">
        <v-card-title class="pb-6">
          {{ $t("productCharacteristics") }}
        </v-card-title>
        <v-card-text>
          <div
            v-for="(item, i) in titles"
            :key="`product-info-${i}`"
            class="about-product__main__info__inner"
          >
            <span class="about-product__main__info__inner__title">
              {{ item.text }}
            </span>
            <span
              class="about-product__main__info__inner__value"
              v-if="product && product[item.value]"
            >
              {{ product[item.value] }}
            </span>
            <span v-else>-</span>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "About-product",
  data() {
    return {
      qrCode: null,
      images: [
        "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cGhvbmV8ZW58MHx8MHx8&w=1000&q=80",
        "https://media.istockphoto.com/id/910633906/photo/new-apple-iphone-x-front-view-on-white-background.jpg?s=612x612&w=0&k=20&c=dl_9XInHaPKGAhO0Eq99hqjyGuxemEbuFDQXmd0fdmY=",
        "https://www.popsci.com/uploads/2021/01/11/7INONBL2EBG2TJ4X763TTOK7RI.jpg",
        "https://cdn.vox-cdn.com/thumbor/nCGiEutIdgMo5ucBvAQuH3-zR2g=/0x0:2040x1360/1400x1400/filters:focal(1020x680:1021x681)/cdn.vox-cdn.com/uploads/chorus_asset/file/19206339/akrales_190913_3628_0277.jpg",
      ],
      mainPhoto:
        "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cGhvbmV8ZW58MHx8MHx8&w=1000&q=80",
      product: {
        productName: "Samsung A51",
        count: "1 шт.",
        contractCode: "32",
        productTypeName: "1090 product type",
        accountingCode: null,
        warehouseName: "Mamuriy",
        productGroupName: "Texnika",
        placedBy: "OMTK",
        placedDate: "30.08.2022 - 08:54",
        deliveredDate: "30.08.2022 - 08:54",
        takenAwayDate: "30.08.2022 - 08:54",
      },
      titles: [
        {
          value: "productName",
          text: this.$t("productName"),
        },
        {
          value: "contractCode",
          text: this.$t("nContract"),
        },
        {
          value: "productTypeName",
          text: this.$t("typeProduct"),
        },
        {
          value: "accountingCode",
          text: this.$t("accountCode"),
        },
        {
          value: "count",
          text: this.$t("count"),
        },
        {
          value: "warehouseName",
          text: this.$t("warehouse"),
        },
        {
          value: "id",
          text: this.$t("qrCode"),
        },
        {
          value: "productGroupName",
          text: this.$t("productGroup"),
        },
        {
          value: "placedBy",
          text: this.$t("placedBy"),
        },
        {
          value: "placedDate",
          text: this.$t("placedDate"),
        },
        {
          value: "deliveredDate",
          text: this.$t("deliveredDate"),
        },
        {
          value: "takenAwayDate",
          text: this.$t("takenAwayDate"),
        },
      ],
    };
  },
  methods: {
    changeMainImage(image) {
      this.mainPhoto = image;
    },
    async getProductDetails() {
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get(
          `product-item/qr-code/full-info/${this.qrCode}`
        );
        this.items = { ...data };
        this.qrCode = null;
        this.$refs.formObs.reset();
      } catch (e) {
        const {
          /**
           * @type {Object}
           * @property {function} setErrors
           */
          formObs,
        } = this.$refs;
        if (
          e.response &&
          e.response.data &&
          e.response.data.errors &&
          e.response.data.errors.message
        ) {
          formObs.setErrors({
            id: this.$t(
              `serverErrorMessages.${e.response.data.errors.message}`
            ),
          });
        }
      } finally {
        this.clearLoading();
      }
    },
  },
  computed: {
    headers() {
      return [
        {
          value: "productName",
          text: this.$t("productName"),
        },
        {
          value: "contractCode",
          text: this.$t("nContract"),
        },
        {
          value: "productTypeName",
          text: this.$t("typeProduct"),
        },
        {
          value: "accountingCode",
          text: this.$t("accountCode"),
        },
        {
          value: "count",
          text: this.$t("count"),
        },
        {
          value: "warehouseName",
          text: this.$t("warehouse"),
        },
        {
          value: "id",
          text: this.$t("qrCode"),
        },
        {
          value: "productGroupName",
          text: this.$t("productGroup"),
        },
        {
          value: "placedBy",
          text: this.$t("placedBy"),
        },
        {
          value: "placedDate",
          text: this.$t("placedDate"),
        },
        {
          value: "deliveredDate",
          text: this.$t("deliveredDate"),
        },
        {
          value: "takenAwayDate",
          text: this.$t("takenAwayDate"),
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.about-product {
  &__main {
    display: flex;

    &__images {
      min-width: 324px;
      max-width: 100%;

      &__main-image {
        width: 292px;
        height: 292px;
        position: relative;
        border: 1px solid #dfe2e9;
        border-radius: 6px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          //left: 50%;
          //top: 50%;
          //transform: translate(-50%, -50%);
        }

        &__no-image {
          width: 50% !important;
          height: 50% !important;
          animation: anim ease-in-out 1.5s infinite;
        }
      }

      &__variants {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 16px;

        &__image {
          transition: 0.1s all;

          &:hover {
            transform: scale(0.94);
          }
        }

        &__img-tag {
          border-radius: 6px;
          max-height: 87px;
          width: 100%;
          object-fit: cover;
          border: 1px solid #dfe2e9;
          transition: 0.5s all;
          &--copy {
            position: absolute;
            z-index: -1;
            left: -10000px;
          }
        }
      }
    }

    &__info {
      width: 100%;

      &__inner {
        background: #f9fbfe;
        padding: 12px 44px;
        border-radius: 4px;
        margin-bottom: 8px;

        &__title {
          font-size: 12px;
          color: #a2a5b9;
          display: inline-block;
          text-align: end;
          margin-right: 50px;
          width: 144px;
        }

        &__value {
          font-size: 16px;
          color: #48545d;
        }
      }
    }
  }

  .v-input__slot {
    min-height: 40px;
    min-width: 308px;
    max-width: 100%;

    input {
      background: unset !important;
      min-height: unset !important;
      border: none;
      border-radius: unset !important;
      font-family: "Rubik", sans-serif;
      font-weight: 500;
      letter-spacing: 0.2px;
    }
  }
}

@media screen and (max-width: 720px) {
  .about-product {
    &__main {
      flex-direction: column;
      align-items: start;

      &__images {
        min-width: unset !important;
        width: 100%;
      }

      &__info {
        margin-top: 16px;
      }
    }
  }
}

@keyframes anim {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.95);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
